declare global {
	namespace JSX {
		interface IntrinsicElements {
			[_: string]: Attributes;
		}

		type Element = HTMLElement;
	}
}

export type CSSProperties = {
	[K in keyof CSSStyleDeclaration as number extends K ? never : CSSStyleDeclaration[K] extends string ? K : never]?: CSSStyleDeclaration[K];
};

export type Attributes =
	{ style?: CSSProperties | undefined }
	& { [_: string]: unknown };

export type Props =
	{ style?: CSSProperties | undefined, children?: HTMLElement | string | (HTMLElement | string)[] }
	& { [_: string]: string | undefined };

function _jsx(tagName: string, props: Props, _key?: string): HTMLElement {
	const {
		children,
		style,
		...attributes
	} = props;

	const element = document.createElement(tagName);
	Object.assign(element.style, style);
	Object.assign(element, attributes);
	if (children !== undefined) {
		if (Array.isArray(children)) {
			element.append(...children);
		} else {
			element.append(children);
		}
	}

	return element;
}

export const jsx = _jsx;
export const jsxs = _jsx;
export const jsxDEV = _jsx;
